const mixin = {
  data () {
    return {
      items: [],
      total: 0,
      page: 1,
      pageSize: 20,
      activeFilters: {},
      maxCharChip: 50,
      filters: []
    }
  },
  methods: {
    async addFilter (filter, reload = true) {
      try {
        this.$root.$emit('showLoading')
        this.filters = []

        if (Array.isArray(filter)) {
          this.filters = filter
        } else {
          this.filters.push(filter)
        }

        this.filters.forEach(filter => {
          this.activeFilters[filter.key] = {
            value: filter.value,
            keyLabel: filter.keyLabel,
            valueLabel: filter.valueLabel
          }
        })

        if (!reload || await this.reloadItems()) {
          this.filters.forEach((filter) => {
            let valueLabel = filter.valueLabel
            if (Array.isArray(valueLabel)) {
              valueLabel = valueLabel.join(', ')
            }

            this.$refs.chipsComponent.addChip(filter.keyLabel, valueLabel, filter.key, filter.value)
          })

          this.$refs.search.clear()
        } else {
          this.filters.forEach((filter) => {
            delete this.activeFilters[filter.key]
          })
        }
      } finally {
        this.$root.$emit('hideLoading')
      }
    },
    async deleteFilter (key) {
      try {
        this.$root.$emit('showLoading')
        if (key) {
          delete this.activeFilters[key]
        }
        await this.reloadItems()
      } finally {
        this.$root.$emit('hideLoading')
      }
    },
    async clearFilters () {
      try {
        this.$root.$emit('showLoading')
        this.activeFilters = {}
        await this.reloadItems()
      } finally {
        this.$root.$emit('hideLoading')
      }
    },
    closeAllRows () {
      const grid = this.$refs.grid
      if (grid) {
        grid.closeAllRows()
      }
    },
    async getItems (callback) {
      this.activeFilters.Page = { value: this.page }
      this.activeFilters.PageSize = { value: this.pageSize }
      try {
        const items = await callback()
        this.items = items.docs
        this.total = items.totalDocs
        return true
      } catch (errors) {
        return false
      } finally {
        if (this.closeAllRows) {
          this.closeAllRows()
        }
      }
    }
  }
}

export default mixin
